import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AdminAllNews from "../../Components/Admin/AdminAllNews";
import SideBar from "../../Components/Admin/SideBar";

const AdminAllNewsPage = () => {
  return (
    <AdminAllNews />
  );
};

export default AdminAllNewsPage;
